<template>

<svg 
	 xmlns="http://www.w3.org/2000/svg"   
	 viewBox="-11.5 780.5 24 24" >
<path d="M-6.5,802.5l-3-3v-2h1l4,4v1H-6.5L-6.5,802.5z M5.5,802.5v-1l4-4h1v2l-3,3H5.5L5.5,802.5z M-0.5,799.5v-2.1
	c-0.64-0.13-1.23-0.38-1.75-0.73l-1.49,1.49l-1.41-1.41l1.49-1.49c-0.35-0.52-0.6-1.12-0.73-1.75h-2.1v-2l2.1,0
	c0.13-0.63,0.39-1.23,0.73-1.75l-1.49-1.49l1.41-1.41l1.49,1.49c0.52-0.35,1.12-0.6,1.75-0.73v-2.1h2v2.1h0
	c0.64,0.13,1.23,0.39,1.75,0.73l1.49-1.49l1.41,1.41l-1.49,1.49c0.35,0.52,0.6,1.12,0.73,1.75h2.1v2H5.4
	c-0.13,0.64-0.39,1.23-0.73,1.75l1.49,1.49l-1.41,1.41l-1.49-1.49c-0.52,0.35-1.11,0.6-1.75,0.73v2.1H-0.5L-0.5,799.5z M0.5,795.5
	c1.67,0,3-1.33,3-3s-1.34-3-3-3c-1.67,0-3,1.33-3,3S-1.17,795.5,0.5,795.5z M-9.5,787.5v-2l3-3h2v1l-4,4H-9.5L-9.5,787.5z
	 M9.5,787.5l-4-4v-1h2l3,3v2H9.5L9.5,787.5z"/>
</svg>

</template>